import { HttpRequestState } from "src/app/shared/store/shared/http-request-state";

export const DEFAULT_APPLICATION_STATE: ApplicationFeatureState = {};

export interface ApplicationFeatureState extends HttpRequestState {
  applicationId?: string;
  applicationDocuments?: ApplicationDocument[];
}

export interface ApplicationDocument {
  filenameWithExtension: string;
  mimeType: MimeType.PDF;
  applicationDocumentType: ApplicationDocumentType;
  documentUrl: string | undefined;
  externalSignDocumentUrl: string | undefined;
}

export enum MimeType {
  PDF = "application/pdf",
  JPEG = "image/jpeg",
  GIF = "image/gif",
  PNG = "image/png",
  TIFF = "image/tiff",
}

export enum ApplicationDocumentType {
  APPLICATION = "application",
}
